import { MASK_TIN } from "../../redux/actions/action.types";

export default function maskTin(booleanVal: boolean, stateSetter: any) {
  stateSetter({
    type: MASK_TIN,
    payload: booleanVal,
  });
}
